import { Http } from "@/plugins/http";

export class AllergyService {
  /**
   * Возвращает список типов аллергий
   * @return Promise<*>
   */
  static getTypes() {
    return Http.get(`v1/allergy-references/types`).then(response => response.data.data);
  }

  /**
   * Возвращает список
   * @return Promise<*>
   */
  static getAllergens(type) {
    return Http.get(`v1/allergy-references/allergens`, { params: { type: type } }).then(response => response.data.data);
  }

  /**
   * Возвращает список
   * @return Promise<*>
   */
  static getAreas() {
    return Http.get(`v1/allergy-references/areas`).then(response => response.data.data);
  }

  /**
   * Возвращает список
   * @return Promise<*>
   */
  static getReactions() {
    return Http.get(`v1/allergy-references/reactions`).then(response => response.data.data);
  }

  /**
   * Возвращает список
   * @return Promise<*>
   */
  static getDegrees() {
    return Http.get(`v1/allergy-references/degrees`).then(response => response.data.data);
  }
}
